require("plugins/slider/slick");

var hero = hero || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ($) {

    $.fn.multimediaSlideshow = function (options) {
        return this.each(function () {
            var multimediaSlideshow = Object.create(hero.multimediaSlideshow);
            multimediaSlideshow.init(this, options);
        });
    };

    $.fn.multimediaSlideshow.options = {};

    hero.multimediaSlideshow = {

        init: function (elem, options) {
            var self = this;
            self.$container = $(elem);

            // Slide Elements
            self.$slider = self.$container.find(".mm-slideshow__slider");
            self.$slides = self.$container.find(".mm-slideshow__slide");
            self.$currentSlide;

            // Timer Elements
            self.$timer = self.$container.find(".mm-slideshow__progress-bar");
            self.$speed = self.$container.data("time");
            self.bindElements();

        },

        bindElements: function () {
            var self = this;

            self.$slider.on("init", function (event, slick) {
                if (slick.slideCount > 1) {
                    self.$slides.each(function (index, item) {
                        var $slide = $(item);
                        var $currentSlideNr = $('.overlay-info__current', $slide);
                        // if(index == 0){
                        //   $currentSlideNr.addClass('active');
                        // }
                        var $totalSlideNr = $('.overlay-info__total', $slide);
                        $currentSlideNr.text(index + 1);
                        $totalSlideNr.text(slick.slideCount);
                    });
                    self.timerToggle();
                } else {
                    self.singleSlide();
                }
                self.$container.addClass('initialized');
            });

            self.$slider.on("beforeChange", function (event, slick, currentSlide) {
                self.clearTimer();
            });

            self.$slider.on("afterChange", function (event, slick, currentSlide) {
                self.timerToggle();
            });

            var options = $.extend({
                dots: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: self.$speed,
                pauseOnHover: false,
                pauseOnFocus: true,
                lazyLoad: 'progressive',
                draggable: true,
                adaptiveHeight: true,
                prevArrow: $('.mm-slideshow__button--prev', self.$container),
                nextArrow: $('.mm-slideshow__button--next', self.$container)
            }, self.$slider.data('slick'));

            self.$slider.slick(options);

        },
        timerToggle: function () {
            var self = this;

            self.$timer.css({
                width: "0%"
            }).animate({
                width: "100%"
            }, {
                duration: self.$speed,
                queue: false,
                easing: "linear"
            });
        },
        clearTimer: function () {
            var self = this;

            self.$timer.stop().css({
                width: "0%"
            });
        },
        singleSlide: function () {
            var self = this;
            self.$container.find(".overlay-info__ticker").remove();
        }
    }
});